var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFancyArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-300 -80 800.001 511.001",
    style: {
      enableBackground: "new 0 0 511.001 511.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 250 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.803,2.197c-2.122-2.122-5.304-2.775-8.089-1.66l-96,38.4C401.867,40.076,400,42.834,400,45.9v54.494L116.394,384.001 H55.5c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h45.894l-9,9H31.5c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h45.894l-9,9 H7.5c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5H64v56.5c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-60.894l9-9v45.894 c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-60.894l9-9v45.894c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-60.894 l283.606-283.606H465.1c3.067,0,5.825-1.867,6.963-4.714l38.4-96C511.578,7.501,510.925,4.319,508.803,2.197z M460.023,96.001 h-34.416l35.197-35.197c2.929-2.929,2.929-7.678,0-10.606c-2.929-2.929-7.678-2.929-10.606,0L415,85.394V50.978l75.037-30.015 L460.023,96.001z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFancyArrow);
export default __webpack_public_path__ + "static/media/fancy-arrow.80fc3e4e38cc9757d66d4cd4c4f5beb0.svg";
export { ForwardRef as ReactComponent };